import styled, { css } from 'styled-components';
import SVG from 'react-inlinesvg';
// Utils
import { breakpoint } from '../../theme/breakpoint';
import { addSubPx } from '../../styled/utils';
// Components
import CTA from '../../cta';
import DefaultButton from '../../button';
import { buttonStyles } from '../../styled/buttons';

const sub1Px = addSubPx(-1);

export const PrimaryNavSplitBtn = styled.div`
  ${buttonStyles};
  padding: 0;
  display: flex;
  align-items: center;

  &:focus,
  &:hover {
    button::before {
      border-left-color: #f799a5; // 60% lighten of accessibleBrand
    }
  }

  // left hand side of split button, ie housing advice
  a {
    padding: ${({ theme }) =>
      `${sub1Px(theme.spacing.small)} ${theme.spacing.small} ${
        theme.spacing.small
      }`};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.palette.white};

    &:focus,
    &:hover {
      color: ${({ theme }) => theme.palette.white};
    }

    &:focus {
      background-color: ${({ theme }) => theme.palette.primaryLink};
    }

    &:after {
      content: none;
    }
  }

  // right hand side of split button, dropdown
  button {
    color: ${({ theme }) => theme.palette.white};
    position: relative;

    &::before {
      content: '';
      border-left: 2px solid ${({ theme }) => theme.palette.borderDark};
      position: absolute;
      left: 0;
      top: ${({ theme }) => theme.spacing.tiny};
      bottom: ${({ theme }) => theme.spacing.tiny};
    }

    &:focus {
      background-color: ${({ theme }) => theme.palette.primaryLink};
    }
  }
`;

export const SearchButton = styled(DefaultButton)`
  margin-left: 4px;
`;

export const SearchBtnToggle = styled(DefaultButton)`
  margin-left: ${({ theme }) => theme.spacing.tiny};

  ${({ $active }) =>
    $active &&
    css`
      background-color: transparent;

      &:focus,
      &:hover {
        color: ${({ theme }) => theme.palette.primaryLink};
      }
    `};
`;

export const StyledDonateButton = styled(CTA)`
  ${({ size }) =>
    size === 'regular' &&
    // NOTE: the desktop button
    css`
      display: none;

      ${breakpoint.desktop`
        margin-left: ${({ theme }) => theme.spacing.medium};
        display: block;
      `}
    `};
`;

export const MobileMenuBtn = styled(DefaultButton)``;

export const MobileMenuIcon = styled(SVG)`
  display: block;
  width: ${({ theme }) => theme.spacing.standard};
`;

export const MobileButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
  height: ${({ theme }) => theme.spacing.xlarge};

  a + button,
  button + button {
    margin-left: ${({ theme }) => theme.spacing.tiny};
  }
`;

export const DesktopButtonWrapper = styled.div`
  display: none;

  ${breakpoint.desktop`
    display: flex;
    margin-left: auto;
    align-items: center;
  `}
`;
